import { store } from "@/store";

export const logoutRoute = {
  path: "/logout",
  async beforeEnter(to, from, next) {
    await store.dispatch("auth/logout");
    next("/login");
  },
};
